import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Calendar, Avatar, List, Table, Progress } from "antd";
import VirtualList from "rc-virtual-list";
import { useContext } from "react";
import {
	EditOutlined,
	EllipsisOutlined,
	SettingOutlined,
} from "@ant-design/icons";
import { UserContext } from "../../UserContext";

const { Meta } = Card;

const Analytics = () => {
	const [analytics,setAnalytics] = useState({});
	const [loading,setloading] = useState(false);
	const {instructorapiuri,token} = useContext(UserContext)
	 const GenerateArticles = async (submodule) => {
			setloading(true);

			const response = await fetch(
				`${instructorapiuri}/inst/analytics`,
				{
					method: "GET",
					headers: {
						"content-type": "application/json",
						Authorization: "BEARER " + token,
					},
				}
			);
			const data = await response.json();
			console.log(data);

			if (data && data.resp ) {
				setAnalytics(data.resp);
			}
			setloading(false);
		};
	return (
		<>
			<div className="section-1">
				<div className="Profile-section">
					<Card
						style={{
							minWidth: 300,
							maxWidth: 450,
							height: 325,
						}}>
						<Meta
							avatar={
								<Avatar
									src="https://xsgames.co/randomusers/avatar.php?g=pixel"
									style={{ width: "50px", height: "50px" }}
								/>
							}
							title="Mareedu Satyanarayana"
							description="20VV1A0529"
						/>
						<br />
						<div className="user-details">
							Degree&nbsp;
							<span>B.Tech</span>
						</div>
						<div className="user-details">
							Department&nbsp;
							<span>Computer Science and Engineering</span>
						</div>
						<div className="user-details">
							Email&nbsp;
							<span>mareedu.satyanarayana.5475@gmail.com</span>
						</div>
						<div className="user-details">
							Contact No&nbsp;
							<span>+91 8919502589</span>
						</div>
					</Card>
				</div>
				<div className="profile-course-details">
					<div>
						{analytics  &&
							analytics.resp.map((item, index) => (
								<div key={index}>
									<h2>Courses Created: {item.coursesCreated}</h2>
									<h3>Student Courses:</h3>
									<ul>
										{Object.entries(item.studCourse).map(
											([courseId, count]) => (
												<li key={courseId}>
													{courseId}: {count}
												</li>
											)
										)}
									</ul>
									<h3>Student Level:</h3>
									<ul>
										{Object.entries(item.studLevel).map(([level, count]) => (
											<li key={level}>
												{level}: {count}
											</li>
										))}
									</ul>
								</div>
							))}
					</div>
				</div>
			</div>
		</>
	);
};

export default Analytics;
